import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TAppSliceState = {
  isUploadLoading: boolean;
  cardholder: string;
  redirectLink: string;
  showServiceWorkerToast: boolean;
  showUpdateModal: boolean;
  applicationInfo: {
    animalResidencyId?: string; // TODO: remove if not used
    animalId: string;
  };
  fromOnboarding: boolean;
  notificationHeight: number;
  headerHeight: number;
};

const initialState: TAppSliceState = {
  isUploadLoading: false,
  cardholder: '',
  redirectLink: '',
  showServiceWorkerToast: false,
  showUpdateModal: false,
  applicationInfo: {
    animalResidencyId: '',
    animalId: '',
  },
  fromOnboarding: false,
  notificationHeight: 0,
  headerHeight: 0,
};

const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setIsUploadLoading(state, action: PayloadAction<boolean>) {
      state.isUploadLoading = action.payload;
    },
    setCardholder(state, action: PayloadAction<string>) {
      state.cardholder = action.payload;
    },
    setRedirectLink(state, action: PayloadAction<string>) {
      state.redirectLink = action.payload;
    },
    setShowServiceWorkerToast(state, action: PayloadAction<boolean>) {
      state.showServiceWorkerToast = action.payload;
    },
    setShowUpdateModal(state, action: PayloadAction<boolean>) {
      state.showUpdateModal = action.payload;
    },
    setViewApplicationProps(
      state,
      action: PayloadAction<{
        animalResidencyId?: string;
        animalId: string;
      }>,
    ) {
      state.applicationInfo = action.payload;
    },
    // Everything here belongs to one account, so none of it may survive a
    // sign-in as somebody else — the arriving account would otherwise be sent
    // straight to the outgoing unit's deep link.
    removeAccountScopedState(state) {
      state.redirectLink = '';
      state.applicationInfo = { animalResidencyId: '', animalId: '' };
      state.cardholder = '';
      state.fromOnboarding = false;
    },
    setFromOnboarding(state, action: PayloadAction<boolean>) {
      state.fromOnboarding = action.payload;
    },
    setNotificationHeight(state, action: PayloadAction<number>) {
      state.notificationHeight = action.payload;
    },
    setHeaderHeight(state, action: PayloadAction<number>) {
      state.headerHeight = action.payload;
    },
  },
});

export default appSlice;
